export const USER_INVITED = 'USER_INVITED';
export const TRANSFER_ACCEPTED = 'TRANSFER_ACCEPTED';
export const USER_REMOVED = 'USER_REMOVED';
export const USER_ROLE_UPDATED = 'USER_ROLE_UPDATED';
export const USER_ROLE_UPDATE_SUCCEEDED = 'USER_ROLE_UPDATE_SUCCEEDED';
export const USER_ROLE_UPDATE_FAILED = 'USER_ROLE_UPDATE_FAILED';
export const MAX_ALLOWED_USERS = 30;
